import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import { FileOpener } from '@capacitor-community/file-opener';
import { toast } from 'react-toastify'; // Must be imported if used

export const handleNativeDownload = async (doc, fileName) => {
    // ... (Your PDF output logic is correct)
    const pdfOutput = doc.output('datauristring');
    const base64Data = pdfOutput.split(',')[1]; // Strip the prefix

    try {
        // 2. WRITE FILE: Directory and Encoding are now correctly scoped/imported
        const SUBFOLDER = 'MyReading';
        const pathToFolder = `${SUBFOLDER}/${fileName}`;

        //generate folder 
        try{
            await Filesystem.mkdir({
                path:SUBFOLDER,
                directory:Directory.Documents,
                recursive:true
            })
        }catch(err){
            console.log('igonore this error');
        }

        const savedFile = await Filesystem.writeFile({
            path: pathToFolder,
            data: base64Data,
            // 🛑 Fix: Directory and Encoding MUST be available in scope
            directory: Directory.Documents, 
            encoding: Encoding.Base64,
        });
        console.log("File Saved:", savedFile);
        

        // 4. OPEN FILE
        await FileOpener.open({
            filePath: savedFile.uri,
            contentType: 'application/pdf',
            openWithApp: true 
        });

        toast.success(`File saved and opened: ${fileName}`);
    } catch(err) {
        console.error('Error saving or opening file in Capacitor:', err); // Use console.error
        toast.error("Failed to save and open file. Check app permissions."); 
    }
}